"use client"

import { useEffect, useState } from "react"
import "./Awards.css"

const Awards = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const translations = {
    en: {
      heroTitle: "Awards & Recognition",
      heroDescription:
        "Celebrating excellence in democratic leadership, community service, and contributions to national development.",
      repsAwardTitle: '"Reps of the Year 2024" Award',
      repsAwardDate: "October 2024",
      repsAwardDescription:
        "Conferred by the Democracy Heroes Award Africa in October 2024. The award recognized his contributions to democratic norms, including providing sponsorships for his constituents and facilitating infrastructure development. The award organization stated that he beat several other nominees after a rigorous selection process that reviewed how he managed public funds and created opportunities for young people.",
      repsAwardOrg: "Democracy Heroes Award Africa",
      engineeringDoctorateTitle: "Doctor of Engineering",
      engineeringDoctorateDate: "November 2, 2024",
      engineeringDoctorateDescription:
        "Conferred by the Federal University Dutsin-Ma (FUDMA) in Katsina State on November 2, 2024. This was in recognition of his contributions to the development of education and the engineering profession.",
      engineeringDoctorateOrg: "Federal University Dutsin-Ma (FUDMA)",
      scienceDoctorateTitle: "Doctor of Science",
      scienceDoctorateDate: "July 5, 2025",
      scienceDoctorateDescription:
        "Awarded by the Federal University of Kashere in Gombe State on July 5, 2025. The university recognized his interventions in the education sector.",
      scienceDoctorateOrg: "Federal University of Kashere",
    },
    ha: {
      heroTitle: "Kyaututtuka da Karramawa",
      heroDescription: "Murnar nagarta a jagorancin dimokuradiyya, hidimar al'umma, da gudummawa ga ci gaban kasa.",
      repsAwardTitle: 'Kyautar "Wakilin Shekara 2024"',
      repsAwardDate: "Oktoba 2024",
      repsAwardDescription:
        "Democracy Heroes Award Africa ta ba shi wannan kyauta a watan Oktoba 2024. An ba shi kyautar don gane gudummawarsa ga ka'idojin dimokuradiyya, ciki har da ba da tallafin karatu ga mazabansa da kuma sauƙaƙe ayyukan gine-gine. Kungiyar ta ce ya ci wasu 'yan takara da yawa bayan bincike mai zurfi da ya duba yadda ya sarrafa kudin jama'a da kuma samar da damammaki ga matasa.",
      repsAwardOrg: "Democracy Heroes Award Africa",
      engineeringDoctorateTitle: "Digiri na Uku a Injiniya",
      engineeringDoctorateDate: "Nuwamba 2, 2024",
      engineeringDoctorateDescription:
        "Jami'ar Dutsin-Ma ta Tarayya (FUDMA) a Jihar Katsina ta ba shi wannan digiri a ranar 2 ga Nuwamba, 2024. Wannan ya kasance don gane gudummawarsa ga ci gaban ilimi da sana'ar injiniya.",
      engineeringDoctorateOrg: "Jami'ar Dutsin-Ma ta Tarayya (FUDMA)",
      scienceDoctorateTitle: "Digiri na Uku a Kimiyya",
      scienceDoctorateDate: "Yuli 5, 2025",
      scienceDoctorateDescription:
        "Jami'ar Kashere ta Tarayya a Jihar Gombe ta ba shi wannan kyauta a ranar 5 ga Yuli, 2025. Jami'ar ta gane gudummawarsa a fannin ilimi.",
      scienceDoctorateOrg: "Jami'ar Kashere ta Tarayya",
    },
  }

  const t = translations[language]

  return (
    <div className="awards">
      {/* Hero Section */}
      <section className="awards-hero">
        <div className={`awards-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroDescription}</p>
        </div>
      </section>

      {/* Awards Content */}
      <div className="awards-content">
        {/* Reps of the Year Award */}
        <div className={`award-item ${isVisible ? "slide-in-left" : ""}`}>
          <img src="/images/award1.jpeg" alt="Reps of the Year 2024 Award" className="award-image" />
          <div className="award-details">
            <h3>{t.repsAwardTitle}</h3>
            <div className="award-date">{t.repsAwardDate}</div>
            <p className="award-description">{t.repsAwardDescription}</p>
            <div className="award-organization">{t.repsAwardOrg}</div>
          </div>
        </div>

        {/* Doctor of Engineering */}
        <div className={`award-item ${isVisible ? "slide-in-right" : ""}`}>
          <img src="/images/award2.jpeg" alt="Doctor of Engineering Award" className="award-image" />
          <div className="award-details">
            <h3>{t.engineeringDoctorateTitle}</h3>
            <div className="award-date">{t.engineeringDoctorateDate}</div>
            <p className="award-description">{t.engineeringDoctorateDescription}</p>
            <div className="award-organization">{t.engineeringDoctorateOrg}</div>
          </div>
        </div>

        {/* Doctor of Science */}
        <div className={`award-item ${isVisible ? "slide-in-left" : ""}`}>
          <img src="/images/award3.jpeg" alt="Doctor of Science Award" className="award-image" />
          <div className="award-details">
            <h3>{t.scienceDoctorateTitle}</h3>
            <div className="award-date">{t.scienceDoctorateDate}</div>
            <p className="award-description">{t.scienceDoctorateDescription}</p>
            <div className="award-organization">{t.scienceDoctorateOrg}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Awards
